// Exports
export default {
	"CameraVideo": "CameraVideo_xDbEY",
	"mirror": "mirror_uqPXt",
	"UnsupportedMessage": "UnsupportedMessage_7nVyp",
	"select": "select_+8gO9",
	"selectDisabled": "selectDisabled_op0a9",
	"cameraWrapper": "cameraWrapper_vbARa",
	"spinOverlay": "spinOverlay_fUKcH",
	"spinVisible": "spinVisible_XjfAH",
	"spin": "spin_OE6SY"
};
